import React from 'react';
import BadgeSolid, { BadgeSizeMM } from './BadgeSolid';
import BadgeOutline from './BadgeOutline';
import BadgeOutlineThin from './BadgeOutlineThin';
import { SaleBadgeContainer, SaleBadgeLabel, SolidBadgeText, OutlineBadgeText } from './styled';
export var BadgeTypes = /*#__PURE__*/function (BadgeTypes) {
  BadgeTypes[BadgeTypes["Solid"] = 0] = "Solid";
  BadgeTypes[BadgeTypes["Outline"] = 1] = "Outline";
  BadgeTypes[BadgeTypes["OutlineThin"] = 2] = "OutlineThin";
  return BadgeTypes;
}({});
var SaleBadge = function SaleBadge(_ref) {
  var children = _ref.children,
    className = _ref.className,
    size = _ref.size,
    type = _ref.type;
  return /*#__PURE__*/React.createElement(SaleBadgeContainer, {
    className: className
  }, type == BadgeTypes.Solid && /*#__PURE__*/React.createElement(BadgeSolid, {
    size: size
  }), type == BadgeTypes.Outline && /*#__PURE__*/React.createElement(BadgeOutline, {
    size: size
  }), type == BadgeTypes.OutlineThin && /*#__PURE__*/React.createElement(BadgeOutlineThin, {
    size: size
  }), /*#__PURE__*/React.createElement(SaleBadgeLabel, null, type === BadgeTypes.Solid ? /*#__PURE__*/React.createElement(SolidBadgeText, null, children) : /*#__PURE__*/React.createElement(OutlineBadgeText, null, children)));
};
export default SaleBadge;
export { BadgeSizeMM };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/SaleBadgeMMVariant/SaleBadge.js
// module id = 3990
// module chunks = 11